import React, { Component } from 'react';
import { connect } from 'react-redux';

import Login from '../profile/login';

class Frontpage extends Component {
  render() {
    return <Login />;
  }
}

export default connect(({ auth: { user } }) => ({ user }))(Frontpage);
